<template>
  <accordion-section
    :open="section === 6"
    :valid="!!primaryCategory"
    @selected="$emit('openSection', 6)"
  >
    <template #heading>
      Categories
    </template>

    <custom-multiselect
      v-model="primaryCategory"
      :close-on-select="true"
      :options="gbpCategories"
      :searchable="true"
      :disabled="!canEditLocation"
      label="Select primary category"
    />

    <custom-multiselect
      v-model="additionalCategories"
      :options="gbpCategories"
      :searchable="true"
      :disabled="!canEditLocation"
      label="Select additional categories (max 9)"
      mode="tags"
      :max="9"
      :validation-errors="validationErrors['categories.additionalCategories']"
    />

    <div class="recommendations">
      <span>Recommendations</span>
      <ul>
        <li>
          Make sure the primary category best represents your business. It is the only one that people see on your
          business listing.
        </li>
        <li>Take advantage of additional categories and add as many as apply to your business.</li>
        <li>Do NOT use categories if they do not directly apply to your business.</li>
      </ul>
    </div>
  </accordion-section>
</template>

<script>
import _ from 'lodash';
import AccordionSection from "../items/AccordionSection";
import {mapActions, mapGetters} from "vuex";
import CustomMultiselect from "../../../../../views/reports/components/global/forms/CustomMultiselect";

export default {
  components: {
    CustomMultiselect,
    AccordionSection
  },
  props: {
    section: {
      type: Number,
      required: true,
    },
  },
  emits: ['openSection'],
  computed: {
    ...mapGetters('user', [
        'canEditLocation',
    ]),
    ...mapGetters('businessProfile', [
      'gbpCategories',
      'validationErrors',
    ]),
    primaryCategory: {
      get() {
        const {name} = this.$store.getters['businessProfile/primaryCategory'];
        return [name];
      },
      set(name) {
        const category = {
          'name': name,
          'displayName': this.gbpCategories[name]
        }
        this.updatePrimaryCategory(category);
      }
    },
    additionalCategories: {
      get() {
        let parsedCategories = [];
        _.forEach(this.$store.getters['businessProfile/additionalCategories'], (category) => {
          const {name} = category;
          parsedCategories.push(name);
        });
        return parsedCategories;
      },
      set(categoriesArray) {
        this.updateAdditionalCategoriesFromArray(categoriesArray);
      }
    }
  },
  mounted() {
  },
  methods: {
    ...mapActions({
      updatePrimaryCategory: 'businessProfile/updatePrimaryCategory',
      updateAdditionalCategoriesFromArray: 'businessProfile/updateAdditionalCategoriesFromArray',
    })
  },
}
</script>
